/*global FB*/
import React from 'react'
import css from './style.scss'

class FBComponent extends React.Component{
  FBIsReady(){
    console.log("you must implement FBIsReady")
  }
  componentDidMount() {
    if(window.FB){
      this.FBIsReady()
    }else{
      (function (d, s, id) {
        const element = d.getElementsByTagName(s)[0];
        const fjs = element;
        let js = element;
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      window.fbAsyncInit = () => {
        FB.init({
          appId: process.env.REACT_APP_FB_APP_ID,
          version: "v2.10",
        });
        FB.AppEvents.logPageView();
        this.FBIsReady()
      };
    }
  }
  render(){
    return null;
  }
}
export default FBComponent


export const PermissionsComponent=(props)=>(
  <div className={css.error}>
    <p>I'm sorry to bother you, but to fully work, <b>{process.env.REACT_APP_NAME}</b> needs these permissions from Facebook:</p>
    <ul>
      <li>Your email address</li>
      <li>Manage your Pages and show a list of the Pages you manage.</li>
      <li>Instagram business accounts connected to your page</li>
      <li>Access insights for the Instagram business accounts connected to your page</li>
    </ul>
    <p>Without these permissions <b>{process.env.REACT_APP_NAME}</b> is useless. Please connect again with Facebook. </p>
  </div>
)
//'



// WEBPACK FOOTER //
// ./src/components/shared/facebook/fb_component.js